<div>
  @if (params()?.cellOptions?.hideValue) {
    <span class="basic-cell"> </span>
  } @else if (isEmpty()) {
    <span class="count-cell-value">-</span>
  } @else {
    <span
      [innerHtml]="sanitizer.bypassSecurityTrustHtml(params()?.valueFormatted ?? params()?.value ?? '' | translate)"
      [ngClass]="{
        capitalize: $safeNavigationMigration(params()?.cellOptions?.capitalize),
        uppercase: $safeNavigationMigration(params()?.cellOptions?.uppercase)
      }"
      class="basic-cell"
    ></span>
  }
</div>
